import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Analytics from '@module/analytics';
import I18n from '@module/i18n';

import Button from '@component/form/element/button';

import Actions from '@app/store/action';

export const CookieWall = ({ acceptTrackers, declineTrackers, closePanel }) => {
  const element = useRef(null);

  const legalPageHref = '/legal/cookies?from_home';

  useEffect(() => {
    Analytics.trackSnowplowEvent({
      category: 'cookie_consent',
      action: 'show_banner',
    });
  }, []);

  useEffect(() => {
    const legalLinks = element.current.querySelectorAll(
      `a[href="${legalPageHref}"]`
    );
    if (legalLinks) {
      Array.from(legalLinks).forEach((legalLink) => {
        legalLink.onclick = () =>
          Analytics.trackSnowplowEvent({
            category: 'cookie_consent',
            action: 'click_legal',
          });
      });
    }
  }, [element]);

  const handleAccept = () => {
    acceptTrackers();
    closePanel();

    Analytics.trackSnowplowEvent({
      category: 'cookie_consent',
      action: 'click_okay',
    });
  };

  const handleDecline = () => {
    declineTrackers();
    closePanel();

    Analytics.trackSnowplowEvent({
      category: 'cookie_consent',
      action: 'click_nope',
    });
  };

  const content = {
    title: {
      __html: I18n.t('transfer.cookie-wall.title'),
    },
    intro: {
      __html: I18n.t('transfer.cookie-wall.intro', {
        href: legalPageHref,
      }),
    },
    text: {
      __html: I18n.t('transfer.cookie-wall.text', {
        href: legalPageHref,
      }),
    },
    accept: I18n.t('transfer.cookie-wall.button-accept'),
    decline: I18n.t('transfer.cookie-wall.button-decline'),
  };

  return (
    <div className="welcome__cookie-notice" ref={element}>
      <div
        className="welcome__cookie-notice-title"
        dangerouslySetInnerHTML={content.title}
      />
      <div
        className="welcome__cookie-notice-intro"
        dangerouslySetInnerHTML={content.intro}
      />
      <div
        className="welcome__cookie-notice-text"
        dangerouslySetInnerHTML={content.text}
      />
      <div className="welcome__buttons">
        <Button
          text={content.accept}
          className="welcome__button welcome__button--accept"
          onClick={handleAccept}
        />
        <Button
          text={content.decline}
          className="welcome__button welcome__button--decline"
          onClick={handleDecline}
        />
      </div>
    </div>
  );
};

CookieWall.propTypes = {
  acceptTrackers: PropTypes.func.isRequired,
  declineTrackers: PropTypes.func.isRequired,
  closePanel: PropTypes.func.isRequired,
};

export const mapDispatchToProps = (dispatch) => ({
  acceptTrackers: () => {
    dispatch(Actions.Session.acceptTrackers());
  },
  declineTrackers: () => {
    dispatch(Actions.Session.declineTrackers());
  },
});

const ConnectedCookieWall = connect(null, mapDispatchToProps)(CookieWall);

ConnectedCookieWall.propTypes = {
  closePanel: PropTypes.func.isRequired,
};

export default ConnectedCookieWall;
